import React from "react";


function UiMainWrapper(props) {
    return (
        <div className="sb-main-wr" {...props} />

    );
}

export default UiMainWrapper;